<template>
  <ais-index
    :index-name="indexNames"
    :searchClient='customSearchClient' >
    <search-engine-page searchPanel="wiki"/>
    <entity-page/>
    <!-- <edit-entity/> -->
  </ais-index>
</template>

<script>
import { customSearchClient } from '../../algolia/customsearch.js'
import AisIndex from '../AisComponents/AisIndex'
import SearchEnginePage from '../SearchEnginePage'
import EntityPage from './Page'
// import EditEntity from './EditPage'

export default {
  name: 'Page',
  data () {
    return {
      indexNames: process.env.VUE_APP_ALGOLIA_WIKI_INDEX_NAME,
      customSearchClient
    }
  },
  components: {
    AisIndex,
    SearchEnginePage,
    EntityPage
    // EditEntity
  }
}
</script>
